<template>
  <div class="page-accueil">
    <main class="main">
      <div class="col-100 container-paves">
        <Popup
          v-if="isPopupActive && shouldPopupOpens && !authenticated"
        ></Popup>
        <router-link
          :to="{ name: 'products' }"
          class="col-50 pave pave-annuaire-produits p-2"
          title="Accéder à l'annuaire complet des produits"
        >
          <h2 class="sm:hidden block text-white text-xl font-semibold">
            Produits
            <span class="text-lg font-normal"
              >(PPP, Biocides, Macro-organismes)</span
            >
          </h2>
          <div class="text-white sm:flex sm:flex-col hidden">
            <div class="text-3xl">Produits</div>
            <div class="flex flex-wrap gap-1">
              <div class="flex-auto">
                <div class="text-xl">Phytopharmaceutiques</div>
                <div class="text-3xl">{{ productCount.phytos }}</div>
              </div>

              <div class="flex-auto">
                <div class="text-xl">Biocides</div>
                <div class="text-3xl">{{ productCount.biocides }}</div>
              </div>
              <div class="flex-auto">
                <div class="text-xl">Macro-organismes</div>
                <div class="text-3xl">{{ productCount.macros }}</div>
              </div>
            </div>
          </div>
        </router-link>
        <router-link
          :to="{ name: 'substances' }"
          class="col-50 pave pave-annuaire-substances p-2"
          title="Accéder à l'annuaire complet des substances actives & macro-organismes"
        >
          <h2 class="sm:hidden block text-white text-xl font-bold">
            Substances actives et Macro-organismes
          </h2>
          <div class="text-white sm:flex sm:flex-col hidden">
            <div class="text-3xl">Substances</div>
            <div class="flex flex-wrap gap-1">
              <div class="flex-auto">
                <div class="text-xl">Substances actives</div>
                <div class="text-3xl">{{ substanceCount.substances }}</div>
              </div>

              <div class="flex-auto">
                <div class="text-xl">Macro-organismes</div>
                <div class="text-3xl">{{ substanceCount.macros }}</div>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-100 container-paves">
        <div
          class="
            col-66
            pave pave-border pave-last-publications
            sm:order-1
            order-2
          "
        >
          <div class="pave-head flex-row justify-between sm:flex hidden">
            <h2 class="pave-title">Dernières publications</h2>
          </div>
          <router-link
            :to="{
              name: 'news',
            }"
            class="sm:hidden block"
          >
            <div class="pave-head flex flex-row justify-between">
              <h2 class="pave-title">Dernières publications</h2>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 bg-orange rounded-3xl text-white p-1 mt-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </router-link>
          <div class="sm:hidden flex bg-white">
            <div class="flex flex-col w-full">
              <router-link
                v-if="lastNews.last.slug"
                :to="{
                  name: 'article',
                  params: { slug: lastNews.last.slug },
                }"
                :title="'Accéder à l\'article ' + lastNews.last.title"
                class="p-4 border-b border-gray-300 flex flex-row"
              >
                <img
                  v-if="
                    lastNews.last.thumbnail.find((thumb) => thumb.size == 192)
                  "
                  :src="
                    lastNews.last.thumbnail.find((thumb) => thumb.size == 192)
                      .file
                  "
                  :alt="lastNews.last.title"
                  class="w-10 h-6 object-cover"
                />
                <p class="ml-2">{{ lastNews.last.title }}</p>
              </router-link>
              <router-link
                v-for="(article, i) in newsParamSlug"
                :key="i"
                class="p-4 border-b border-gray-300 flex flex-row"
                :to="{ name: 'article', params: { slug: article.slug } }"
                :title="'Accéder à l\'article ' + article.title"
              >
                <img
                  v-if="article.thumbnail.find((thumb) => thumb.size == 192)"
                  :src="
                    article.thumbnail.find((thumb) => thumb.size == 192).file
                  "
                  :alt="article.title"
                  class="w-10 h-6 object-cover"
                />
                <p class="ml-2">{{ article.title }}</p>
              </router-link>
            </div>
          </div>
          <div class="pave-content sm:flex hidden">
            <div class="pave_publications">
              <div id="tab1" class="tab-item">
                <div
                  v-if="lastNews.last.thumbnail.length"
                  class="tab-item_image"
                >
                  <router-link
                    v-if="lastNews.last.slug"
                    :to="{
                      name: 'article',
                      params: { slug: lastNews.last.slug },
                    }"
                    :title="'Accéder à l\'article ' + lastNews.last.title"
                  >
                    <img
                      v-if="
                        lastNews.last.thumbnail.find(
                          (thumb) => thumb.size == 192
                        )
                      "
                      :src="
                        lastNews.last.thumbnail.find(
                          (thumb) => thumb.size == 192
                        ).file
                      "
                      :alt="lastNews.last.title"
                    />
                  </router-link>
                </div>

                <div class="tab-item_head">
                  <div class="tab-item_date-cat">
                    <span v-if="lastNews.last.news_date" class="tab-item_date">
                      Le
                      <span class="orange">{{ lastNews.last.news_date }}</span>
                    </span>
                    <span v-if="lastNews.last.tags[0]">
                      -
                      <span class="tab-item_cat">
                        {{ "Catégorie" | pluralize(lastNews.last.tags.length) }}
                        :
                      </span>
                      <span
                        v-for="(tag, i) in lastNews.last.tags"
                        class="tab-item_cat orange"
                        :key="i"
                      >
                        <span v-if="i !== 0">, </span>
                        <router-link
                          :to="{ name: 'news', query: { categorie: tag } }"
                          >{{ tag }}</router-link
                        >
                      </span>
                    </span>
                  </div>
                  <h2 class="tab-item_titre pave-titre">
                    <router-link
                      v-if="lastNews.last.slug"
                      :to="{
                        name: 'article',
                        params: { slug: lastNews.last.slug },
                      }"
                      :title="'Accéder à l\'article ' + lastNews.last.title"
                    >
                      {{ lastNews.last.title }}
                    </router-link>
                  </h2>
                </div>
                <div
                  class="tab-item_description pave-description rte excerpt-text"
                  
                >
                  {{parseHTML(lastNews.last.text).textContent.substring(0,250)+'..'}}
                </div>
                <div class="read">
                  <router-link
                    v-if="lastNews.last.slug"
                    class="orange-link"
                    :to="{
                      name: 'article',
                      params: { slug: lastNews.last.slug },
                    }"
                    :title="'Accéder à l\'article ' + lastNews.last.title"
                  >
                    Lire la suite
                  </router-link>
                </div>
                <div v-if="!lastNews.last.slug">
                  Aucune actualité pour le moment
                </div>
              </div>
            </div>

            <div class="pave_tabs">
              <router-link
                v-for="(article, i) in newsParamSlug"
                :key="i"
                class="pave_tab"
                :to="{ name: 'article', params: { slug: article.slug } }"
                :title="'Accéder à l\'article ' + article.title"
              >
                {{ article.title }}
              </router-link>
              <router-link
                :to="{ name: 'news' }"
                title="Accéder à la liste des actualités"
                class="pave_tab-other orange-link"
              >
                Voir toutes les actualités
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-33 pave pave-border pave-search sm:order-2 order-1">
          <div class="pave-head">
            <h2 class="pave-title">Recherche rapide par usage</h2>
          </div>
          <div class="pave-content">
            <SuggesterInput
              ressource="cultivations"
              fieldname="name"
              verbose="Culture"
              v-model="homeSearchCultivation"
            >
            </SuggesterInput>
            <SuggesterInput
              ressource="targets"
              fieldname="name"
              verbose="Cible"
              v-model="homeSearchTarget"
            >
            </SuggesterInput>
            <router-link :to="{ name: 'products', query: queryParams }">
              <button class="pave-search-btn width-100 orange-background">
                Lancer la recherche
              </button>
            </router-link>
          </div>
        </div>
      </div>

      <div class="col-100 container-paves">
        <div
          v-if="toKnowBlock"
          class="col-33 pave pave-border pave-to-know sm:order-1 order-2"
        >
          <div class="pave-head">
            <h2 class="pave-title sm:block hidden">
              {{ toKnowBlock.title }}
            </h2>
            <router-link
              class="sm:hidden flex flex-row order-2 justify-between"
              :to="{ path: toKnowBlockUrl }"
            >
              <h2 class="pave-title text-sm w-52">
                {{ toKnowBlock.title }}
              </h2>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 bg-orange rounded-3xl mt-2 text-white p-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </router-link>
          </div>
          <div class="pave-content sm:block hidden">
            <p v-html="toKnowBlock.text" class="pave-description rte"></p>
            <div class="read">
              <router-link class="orange-link" :to="{ path: toKnowBlockUrl }">
                Lire la suite
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-33 pave pave-border pave-favs sm:order-2 order-1">
          <div class="pave-head items-center">
            <h2 class="pave-title sm:block hidden">Mes favoris</h2>
            <div class="sm:hidden block">
              <router-link
                :to="{ name: 'favorites' }"
                title="Accèder à la liste complète de vos favoris"
                class="underline"
              >
                Mes favoris
              </router-link>
            </div>
            <div class="sm:hidden block">
              <router-link
                :to="{ name: 'favorites', query: { index: '2' } }"
                title="Accèder à votre liste de recherches"
                class="underline"
              >
                Mes recherches
              </router-link>
            </div>
          </div>
          <div class="pave-content sm:block hidden">
            <div class="flex">
              <ul class="my-favs w-2/3">
                <li
                  v-for="favorite in favorites"
                  :key="favorite.name"
                  class="my-fav"
                  :class="{ 'alert-bell': favorite.alert }"
                >
                  <router-link
                    class="favorite-with-arrow"
                    :to="{
                      name: `${favorite.type}Identity`,
                      params: { id: String(favorite.favorite_id) },
                    }"
                  >
                    {{ favorite.name }}
                  </router-link>
                </li>
                <p v-if="!favorites.length">
                  Aucun favori enregistré pour le moment.
                </p>
              </ul>
              <ul class="my-favs w-1/3">
                <li
                  v-for="search in last_searches"
                  :key="search.name"
                  class="my-fav"
                >
                  <router-link
                    class="favorite-with-arrow"
                    :to="{
                      name: search.search_type.concat('sAdvancedSearch'),
                      params: { results: 'results' },
                      query: buildQueryBySearch(search),
                    }"
                    title="Accèder à la recherche enregistrée"
                  >
                    {{ search.name }}
                  </router-link>
                </li>
                <p v-if="!last_searches.length">
                  Aucune recherche enregistré pour le moment.
                </p>
              </ul>
            </div>

            <div class="favorites-links">
              <router-link
                :to="{ name: 'favorites' }"
                title="Accèder à la liste complète de vos favoris"
                class="orange-link"
              >
                Voir tous les favoris
              </router-link>
              <router-link
                :to="{ name: 'favorites', query: { index: '2' } }"
                title="Accèder à votre liste de recherches"
                class="orange-link"
              >
                Mes recherches enregistrées
              </router-link>
            </div>
          </div>
        </div>

        <div class="col-33 pave pave-slider order-3">
          <swiper ref="swiper" :options="swiperOption">
            <swiper-slide v-for="ad in ads" :key="ad.id">
              <component
                :is="ad.link ? 'a' : 'div'"
                :href="ad.link"
                target="_blank"
                v-if="ad.thumbnail.find((thumb) => thumb.size == 500)"
              >
                <img
                  :src="ad.thumbnail.find((thumb) => thumb.size == 500).file"
                  alt="publicité"
                />
              </component>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <!-- <div class="col-33 pave pave-slider">
          <button
            class="pave-search-btn width-100 orange-background"
            @click="trialOffer"
          >
            Beneficier de l'offre découverte
          </button>
        </div> -->
      </div>
    </main>
  </div>
</template>

<script>
import Ad from "@/api/ads.js";
import New from "@/api/news.js";
import Product from "@/api/products.js";
import Flatpage from "@/api/flatpages.js";
import Substance from "@/api/substances.js";
import Users from "@/api/users.js";
import SuggesterInput from "@/components/SuggesterInput";
import Popup from "@/components/Popup";
import { knowEverythingAboutCropsUrl } from "@/include/urls";
import { mapState } from "vuex";

export default {
  name: "Home",
  components: { SuggesterInput, Popup },

  props: {
    mainMenuDisplay: Boolean,
  },

  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      productCount: {
        phytos: 0,
        macros: 0,
        biocides: 0,
      },
      substanceCount: {
        substances: 0,
        macros: 0,
      },
      lastNews: {
        last: {
          id: null,
          news_date: null,
          tags: [],
          text: null,
          thumbnail: [{ file: null }],
          title: null,
          slug: null,
        },
        others: [{
          id: null,
          news_date: null,
          tags: [],
          text: null,
          thumbnail: [{ file: null }],
          title: null,
          slug: null,
        }],
      },
      homeSearchCultivation: "",
      homeSearchTarget: "",
      toKnowBlockUrl: knowEverythingAboutCropsUrl,
      toKnowBlock: null,
      ads: [],
      alertsCount: 0,
      favorites: [],
      isModalVisible: false,
      last_searches: [],
    };
  },

  created() {
    
    Product.count().then((response) => {
      this.productCount = {
        phytos: response.product_count,
        macros: response.macro_count,
        biocides: response.biocide_count,
      };
    });
    Substance.count().then((response) => {
      this.substanceCount = {
        substances: response.substance_count,
        macros: response.macro_count,
      };
    });
    New.lastNews().then((response) => {
      this.lastNews = response.last.id || response.others[0].id ? response : this.lastNews;
      
    });
    Flatpage.retrieve({ url: this.toKnowBlockUrl }, false)
      .then((response) => {
        this.toKnowBlock = response;
        if (this.toKnowBlock.text.length > 350) {
          this.toKnowBlock.text =
            this.toKnowBlock.text.substring(0, 350) + "...";
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          this.toKnowBlock = null;
        }
      });
    Ad.list({ type: "Normale" }).then((response) => {
      this.ads = response;
    });
    Users.getAlertsCount()
      .then((response) => {
        this.alertsCount = response;
      })
      .catch(() => {});

    Users.getLastFavorites()
      .then((response) => {
        this.favorites = response;
      })
      .catch(() => {});

    Users.getlastSearches().then((response) => {
      this.last_searches = response;
    });
  },

  methods: {
    // trigger slider resize when main menu is opened/closed
    resizeSlides() {
      setTimeout(() => this.$refs.swiper.swiper.resize.resizeHandler(), 500);
    },
    async trialOffer() {
      // TODO @alexandre: improve with loader
      await Users.trialOffer();
    },
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    buildQueryBySearch(search) {
      const params = JSON.parse(search.search);
      return { ...params, searchId: search.id };
    },
    parseHTML(html) {
      var t = document.createElement("template");
      t.innerHTML = html;
      return t.content;
    },

    
    
  },
  computed: {
    newsParamSlug() {
      return this.lastNews.others[0].slug ? this.lastNews.others : ''
    }, 
    isPopupActiveInLocalStorage() {
      return JSON.parse(localStorage.getItem("isPopupActive"));
    },
    isPopupActive() {
      return this.$store.state.popup.isPopupActive;
    },
    shouldPopupOpens() {
      return this.$store.state.popup.shouldPopupOpens;
    },
    queryParams() {
      let queryParams = {};
      if (this.homeSearchCultivation) {
        queryParams["cultivations"] = this.homeSearchCultivation;
      }
      if (this.homeSearchTarget) {
        queryParams["targets"] = this.homeSearchTarget;
      }
      return queryParams;
    },
    authenticated() {
      return this.$store.getters["authent/isAuthenticated"];
    },
  },

  watch: {
    mainMenuDisplay: {
      handler: function () {
        this.resizeSlides();
      },
    },
  },

  // parseText() {
  //     let documentFragment = parseHTML('<td>Test</td>');
  //     return documentFragment.textContent
  // }
};
</script>
